<template>
  <div class="anlist box">
    <div class="anlist_content">
      <p class="breakhead book_nav" v-if="breakArr.type == 1">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">医案库</span>
        <span class="nav_middle" @click="goindex(2)">{{breakArr.ksname}}</span>
        <span class="nav_current">{{breakArr.name}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 2">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">医案库</span>
        <span class="nav_current">{{breakArr.name}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 3">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">医案库</span>
        <span class="nav_current">{{breakArr.name}}</span>
      </p>
      <div class="loading" v-show="isloading">
        <img src="../../assets/an/search_loading.gif" alt />
        <p class="loading_p">
          玩命加载中
          <span class="dotting"></span>
        </p>
      </div>
      <div v-show="!isloading"
        class="anlist_content_ul infinite-list"
        ref="scrollList"
        v-infinite-scroll="pushnext"
        infinite-scroll-disabled="isquestionall"
        infinite-scroll-distance="10"
        infinite-scroll-immediate="false">
        <div
          class="anlist_content_li"
          v-for="(item,index) in anlistArr"
          :key="index"
          @click="goDetail(item)"
        >
          <p class="anlist_content_li_p1">{{item.illness_name}}</p>
          <p class="anlist_content_li_p2">{{item.doctor}}</p>
          <p class="anlist_content_li_p3" v-if="item.symptom"><span>证候表现</span>：{{item.symptom}}</p>
          <p v-else></p>
          <p class="anlist_content_li_p4" v-if="item.provenace"><span>出处</span>：{{item.provenace}}</p>
          <p v-else></p>
        </div>
        <div class="pagination" v-if="total_pages>1">
          <el-pagination
            @prev-click="handlePre"
            @next-click="handleNext"
            @current-change="changePage"
            :current-page="current_page"
            background
            layout="prev, pager, next"
            :page-size="1"
            :total="total_pages"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breakArr: {},
      anlistArr: [],
      current_page: 1,
      total_pages: null,
      isloading: true
    };
  },
  created() {
    if (this.$route.query.t == 1) {
      this.breakArr = {
        name: this.$route.query.name,
        ksname: this.$route.query.ks,
        type: this.$route.query.t
      };
    } else if (this.$route.query.t == 2 || this.$route.query.t == 3) {
      this.breakArr = {
        name: this.$route.query.name,
        type: this.$route.query.t
      };
    }

    this.get_list();
  },
  methods: {
    get_list() {
      let that = this;
      let params = {};
      if (this.breakArr.type == 1 || this.breakArr.type == 3) {
        params = {
          type: "illness",
          illness_name: this.breakArr.name,
          page:this.current_page,
          page_size:10
        };
      } else {
        params = {
          type: "doctor",
          doctor_name: this.breakArr.name
        };
      }
      params["page"] = this.current_page;
      // console.log(params)
      this.$axios.get("zk_an/cases", { params }).then(function(res) {
          // console.log(res);
        if (res.data.status_code == 200) {
          // that.anlistArr = res.data.data.cases;
          that.total_pages = parseInt(res.data.data.total_pages);
          that.current_page = parseInt(res.data.data.current_page);
          that.isloading = false;
             if (that.currentpage == 1) {
              that.anlistArr = res.data.data.cases;
            } else {
              that.anlistArr = that.anlistArr.concat(
                res.data.data.cases
              );
            }
        }
      });
    },
    // 点击前一页
    handlePre(val) {
      //val是pagination中的第几页
      //   console.log(val)
      this.current_page = val;
      this.get_list();
      //   }
    },
    // 点击下一页
    pushnext(val) {

      if (this.current_page != this.total_pages) {
        this.current_page += 1;
        this.get_list();
        // this.isloading = true;
      } else {
        // this.isloading = false;
      }
    },
    changePage(val) {
      this.current_page = val;
      this.get_list();
    },
    goindex(num) {
      if (num == 1) {
        this.$router.push({
          path: "/index"
        });
      } else {
        this.$router.push({
          path: "/an",
          name: "an"
        });
      }
    },
    goDetail(item) {
      // anDetail
      if (this.$route.query.t == 1) {
        let pictureUrl = this.$router.resolve({
          path: "/anDetail",
          query: {
            name: this.$route.query.name,
            ks: this.$route.query.ks,
            t: this.$route.query.t,
            cid: item.case_id
          }
        });
        window.open(pictureUrl.href, "_blank");
      } else {
        let pictureUrl = this.$router.resolve({
          path: "/anDetail",
          query: {
            name: this.$route.query.name,
            ks: item.illness_name,
            t: this.$route.query.t,
            cid: item.case_id
          }
        });
        window.open(pictureUrl.href, "_blank");
      }
    }
  }
};
</script>
<style scoped lang="scss"  type="text/css">
@import "../../assets/style/an/an_list.scss";
@import "../../assets/style/an/book_nav.scss";
</style>